/* eslint-disable max-lines */
import { put, takeEvery } from 'redux-saga/effects';
import {
  IAssessSubmitResponsePayload,
  ICSPAssessQuestionnaireRequestPayload,
  IDAQAnswersResponsePayload,
  IDAQuestionnaireResponsePayload,
  IPlanCapabilityRequestPayload,
  ISecurityAssessmentGetObj,
  IUploadAssessmentState,
} from '../../../models/DevopsAnalyticsModels';
import devOpsAnalyticsService from '../../../services/TrafficAnalyticsService/DevOpsAnalyticsService';
import { DashboardActions } from '../../actions/DashboardActions';
import {
  DevOpsAnalyticsAction,
  DevOpsAnalyticsActions,
  DevOpsAnalyticsActionTypes,
} from '../../actions/WebAnalytics/DevopsAnalytics';
import { HitsAnalyticsAction } from '../../actions/WebAnalytics/HitsAnalyticsActions';
import {
  IAssessmentQuestionsResponse,
  IAssessmentResponse,
  IAssessmentResultPayload,
  IDevopsDataResponse,
  IGovAnalysisDataResponse,
} from '../../state/DevOpsAnalyticsState';
import {
  ICSPAssessQuestionnaireListItem,
  IDAQuestionnaireListItem,
  IPlanCardContent,
} from '../../../models/DashboardModels';
import { NotificationTypes } from '../../../../components/notifications/Toast/ToastConstants';
import { ToastActions } from '../../actions/ToastActions';
import { IAssessmentResponsesPayload } from '../../../../pages/Dashboard/DashboardCover/DiscoverAssess/DiscoverAssess';

export function* getDevopsData(action: HitsAnalyticsAction) {
  try {
    const { data } = action;
    const response: IDevopsDataResponse = (yield devOpsAnalyticsService.getCapabilityData(
      data as string,
    ))!;
    yield put(DevOpsAnalyticsActions.getAnalyticsAssessmentSuccess(response));
  } catch (error) {
    if (error instanceof Error) {
      yield put(DevOpsAnalyticsActions.getAnalyticsAssessmentError(error));
    }
  }
}

export function* getGovernanceAnalysisData(action: HitsAnalyticsAction) {
  try {
    const { data } = action;
    const response: IGovAnalysisDataResponse = (yield devOpsAnalyticsService.getGovernanceData(
      data as string,
    ))!;
    yield put(DevOpsAnalyticsActions.getGovernanceAssessmentSuccess(response));
  } catch (error) {
    if (error instanceof Error) {
      yield put(DevOpsAnalyticsActions.getGovernanceAssessmentError(error));
    }
  }
}

export function* postGovernanceAnalysisData(action: DevOpsAnalyticsAction) {
  try {
    const { data } = action;
    const response: IGovAnalysisDataResponse = (yield devOpsAnalyticsService.postGovernanceData(
      data as IUploadAssessmentState,
    ))!;
    yield put(DevOpsAnalyticsActions.postGovernanceAssessmentSuccess());
  } catch (error) {
    if (error instanceof Error) {
      yield put(DevOpsAnalyticsActions.postGovernanceAssessmentError(error));
    }
  }
}

export function* getAssessmentQuestionsWorker(action: DevOpsAnalyticsAction) {
  try {
    const { data } = action;
    const response: IAssessmentQuestionsResponse[] =
      (yield devOpsAnalyticsService.getAssessmentQuestionsService(data as string))!;
    yield put(DevOpsAnalyticsActions.getAssessmentQuestionsSuccess(response));
  } catch (error) {
    if (error instanceof Error) {
      yield put(DevOpsAnalyticsActions.getAssessmentQuestionsError(error));
    }
  }
}
export function* setAssessmentResultWorker(action: DevOpsAnalyticsAction) {
  try {
    const data = action.data as IAssessmentResultPayload;
    const response: string = (yield devOpsAnalyticsService.setAssessmentResultService(
      data as IAssessmentResultPayload,
    ))!;
    yield put(DashboardActions.getAssessmentDataStart(data.projectId));
    switch (data.assessmentType) {
      case 'devops':
        yield put(
          DevOpsAnalyticsActions.getDiscoverAssessmentStart({
            projectId: data.projectId,
            assessmentType: data.assessmentType,
          }),
        );
        break;
      case 'health':
        yield put(DevOpsAnalyticsActions.getBuildDeployAssessmentStart(data.projectId));
        break;
      case 'financialGovernance':
        yield put(
          DevOpsAnalyticsActions.getSecurityGovernanceAssessmentDataStart({
            projectId: data.projectId,
            assessmentType: data.assessmentType,
          }),
        );

        break;

      case 'operationalGovernance':
        yield put(
          DevOpsAnalyticsActions.getSecurityGovernanceAssessmentDataStart({
            projectId: data.projectId,
            assessmentType: data.assessmentType,
          }),
        );
        break;
      case 'strategicGovernance':
        yield put(
          DevOpsAnalyticsActions.getSecurityGovernanceAssessmentDataStart({
            projectId: data.projectId,
            assessmentType: data.assessmentType,
          }),
        );
        break;

      default:
        break;
    }

    yield put(DevOpsAnalyticsActions.setAssessmentResultSSuccess());
  } catch (error) {
    if (error instanceof Error) {
      yield put(DevOpsAnalyticsActions.setAssessmentResultError(error));
    }
  }
}

export function* getBuildDeployAssessmentData(action: HitsAnalyticsAction) {
  try {
    const { data } = action;
    const response: IGovAnalysisDataResponse =
      (yield devOpsAnalyticsService.getBuildDeployAssessmentData({
        assessmentType: 'health',
        projectId: data as string,
      }))!;
    yield put(DevOpsAnalyticsActions.getBuildDeployAssessmentSuccess(response));
  } catch (error) {
    if (error instanceof Error) {
      yield put(DevOpsAnalyticsActions.getBuildDeployAssessmentError(error));
    }
  }
}

export function* getSecurityAssessmentData(action: DevOpsAnalyticsAction) {
  try {
    const { data } = action;

    const response: IGovAnalysisDataResponse =
      (yield devOpsAnalyticsService.getBuildDeployAssessmentData(
        data as ISecurityAssessmentGetObj,
      ))!;
    yield put(DevOpsAnalyticsActions.getSecurityGovernanceAssessmentDataSuccess(response));
  } catch (error) {
    if (error instanceof Error) {
      yield put(DevOpsAnalyticsActions.getBuildDeployAssessmentError(error));
    }
  }
}

export function* getDiscoverDevopsAssessmentData(action: DevOpsAnalyticsAction) {
  try {
    const { data } = action;

    const response: IDevopsDataResponse =
      (yield devOpsAnalyticsService.getBuildDeployAssessmentData(
        data as ISecurityAssessmentGetObj,
      ))!;
    yield put(DevOpsAnalyticsActions.getDiscoverAssessmentSuccess(response));
  } catch (error) {
    if (error instanceof Error) {
      yield put(DevOpsAnalyticsActions.getDiscoverAssessmentError(error));
    }
  }
}

export function* getAssessmentResponses(action: DevOpsAnalyticsAction) {
  try {
    const { data } = action;
    const response: IAssessmentResponse = (yield devOpsAnalyticsService.getAssessmentResponses(
      data as IAssessmentResponsesPayload,
    ))!;
    yield put(DevOpsAnalyticsActions.getAssessmentResponsesSuccess(response));
  } catch (error) {
    if (error instanceof Error) {
      yield put(DevOpsAnalyticsActions.getAssessmentResponsesError(error));
    }
  }
}

export function* getDiscAssesQuestionList(action: DevOpsAnalyticsAction) {
  try {
    const { data } = action;
    const response: IDAQuestionnaireListItem[] =
      yield devOpsAnalyticsService.getDisAssQuestionsList(data as IDAQuestionnaireResponsePayload);
    yield put(DevOpsAnalyticsActions.getDiscAssessQuestionListSuccess(response));
  } catch (error) {
    if (error instanceof Error) {
      yield put(DevOpsAnalyticsActions.getDiscAssessQuestionListError(error));
    }
  }
}

export function* saveDiscAssesQuestionList(action: DevOpsAnalyticsAction) {
  try {
    const { data } = action;
    yield devOpsAnalyticsService.saveDisAssQuestionsList(data as IDAQAnswersResponsePayload);
    yield put(DevOpsAnalyticsActions.saveSubmitDiscAssessQuestionListSuccess());
    yield put(
      ToastActions.showToast({
        description: `Responses Saved Successfully`,
        type: NotificationTypes.SUCCESS,
      }),
    );
  } catch (error) {
    if (error instanceof Error) {
      yield put(DevOpsAnalyticsActions.saveSubmitDiscAssessQuestionListError(error));
      yield put(
        ToastActions.showToast({
          description: `Couldn't Submit Successfully`,
          type: NotificationTypes.ERROR,
        }),
      );
    }
  }
}

export function* updateDiscAssesQuestionList(action: DevOpsAnalyticsAction) {
  try {
    const { data } = action;
    yield devOpsAnalyticsService.updateDisAssQuestionsList(data as IDAQAnswersResponsePayload);
    yield put(DevOpsAnalyticsActions.updateDiscAssessQuestionListSuccess());
    yield put(
      ToastActions.showToast({
        description: `Responses Updated Successfully`,
        type: NotificationTypes.SUCCESS,
      }),
    );
  } catch (error) {
    if (error instanceof Error) {
      yield put(DevOpsAnalyticsActions.updateDiscAssessQuestionListError(error));
      yield put(
        ToastActions.showToast({
          description: `Couldn't Submit Successfully`,
          type: NotificationTypes.ERROR,
        }),
      );
    }
  }
}

export function* getCspAssesQuestionList(action: DevOpsAnalyticsAction) {
  try {
    const { data } = action;
    const response: ICSPAssessQuestionnaireListItem[] =
      yield devOpsAnalyticsService.getCspAssQuestionsList(data as IDAQuestionnaireResponsePayload);
    yield put(DevOpsAnalyticsActions.getCspAssessQuestionListSuccess(response));
  } catch (error) {
    if (error instanceof Error) {
      yield put(DevOpsAnalyticsActions.getCspAssessQuestionListError(error));
    }
  }
}

export function* saveCspAssesQuestionList(action: DevOpsAnalyticsAction) {
  try {
    const payload = action.data as ICSPAssessQuestionnaireRequestPayload;
    yield devOpsAnalyticsService.saveCspAssQuestionsList(
      payload.submitDetails as IAssessSubmitResponsePayload,
    );
    yield put(
      ToastActions.showToast({
        description: `Responses Saved Successfully`,
        type: NotificationTypes.SUCCESS,
      }),
    );
    try {
      const response: ICSPAssessQuestionnaireListItem[] =
        yield devOpsAnalyticsService.getCspAssQuestionsList(
          payload.listFetchDetails as IDAQuestionnaireResponsePayload,
        );
      yield put(DevOpsAnalyticsActions.getCspAssessQuestionListSuccess(response));
    } catch (error) {
      if (error instanceof Error) {
        yield put(DevOpsAnalyticsActions.getCspAssessQuestionListError(error));
      }
    }
    yield put(DevOpsAnalyticsActions.submitCspAssessSuccess());
  } catch (error) {
    if (error instanceof Error) {
      yield put(DevOpsAnalyticsActions.submitCspAssessError(error));
      yield put(
        ToastActions.showToast({
          description: `Couldn't Submit Successfully`,
          type: NotificationTypes.ERROR,
        }),
      );
    }
  }
}

export function* getPlanCapabilityList(action: DevOpsAnalyticsAction) {
  try {
    const { data } = action;
    const response: IPlanCardContent[] = yield devOpsAnalyticsService.getPlanCapabilityList(
      data as string,
    );
    yield put(DevOpsAnalyticsActions.getPlanCapabilityListSuccess(response));
  } catch (error) {
    if (error instanceof Error) {
      yield put(DevOpsAnalyticsActions.getPlanCapabilityListError(error));
    }
  }
}

export function* savePlanCapabilityList(action: DevOpsAnalyticsAction) {
  try {
    const payload = action.data as IPlanCapabilityRequestPayload;
    yield devOpsAnalyticsService.savePlanCapabilityList(payload);
    yield put(
      ToastActions.showToast({
        description: `Data Saved Successfully`,
        type: NotificationTypes.SUCCESS,
      }),
    );
    try {
      const response: IPlanCardContent[] = yield devOpsAnalyticsService.getPlanCapabilityList(
        payload.projectId as string,
      );
      yield put(DevOpsAnalyticsActions.getPlanCapabilityListSuccess(response));
    } catch (error) {
      if (error instanceof Error) {
        yield put(DevOpsAnalyticsActions.getPlanCapabilityListError(error));
      }
    }
    yield put(DevOpsAnalyticsActions.savePlanListSuccess());
  } catch (error) {
    if (error instanceof Error) {
      yield put(DevOpsAnalyticsActions.savePlanListError(error));
      yield put(
        ToastActions.showToast({
          description: `Couldn't Save Data Successfully`,
          type: NotificationTypes.ERROR,
        }),
      );
    }
  }
}

export function* devOpsAnalyticsWatcher() {
  yield takeEvery(DevOpsAnalyticsActionTypes.GET_ANALYTICS_ASSESSMENT_START, getDevopsData);
  yield takeEvery(
    DevOpsAnalyticsActionTypes.GET_GOVERNANCE_ASSESSMENT_START,
    getGovernanceAnalysisData,
  );
  yield takeEvery(
    DevOpsAnalyticsActionTypes.POST_GOVERNANCE_ASSESSMENT_START,
    postGovernanceAnalysisData,
  );
  yield takeEvery(
    DevOpsAnalyticsActionTypes.GET_ASSESSMENT_QUESTIONS_START,
    getAssessmentQuestionsWorker,
  );
  yield takeEvery(
    DevOpsAnalyticsActionTypes.SET_ASSESSMENT_RESULT_START,
    setAssessmentResultWorker,
  );
  yield takeEvery(
    DevOpsAnalyticsActionTypes.GET_BUILD_DEPLOY_ASSESSMENT_START,
    getBuildDeployAssessmentData,
  );
  yield takeEvery(
    DevOpsAnalyticsActionTypes.GET_SECURITY_ASSESSMENT_GRAPH_DATA_START,
    getSecurityAssessmentData,
  );
  yield takeEvery(
    DevOpsAnalyticsActionTypes.GET_DISCOVER_ASSESSMENT_GRAPH_START,
    getDiscoverDevopsAssessmentData,
  );
  yield takeEvery(
    DevOpsAnalyticsActionTypes.GET_ASSESSMENT_RESPONSES_START,
    getAssessmentResponses,
  );
  yield takeEvery(
    DevOpsAnalyticsActionTypes.GET_DISCOVERY_ASS_QUESTIONS_START,
    getDiscAssesQuestionList,
  );
  yield takeEvery(
    DevOpsAnalyticsActionTypes.SUBMIT_SAVE_DISCOVERY_ASS_QUESTIONS_START,
    saveDiscAssesQuestionList,
  );
  yield takeEvery(
    DevOpsAnalyticsActionTypes.UPDATE_ANS_DISCOVERY_ASS_QUESTIONS_START,
    updateDiscAssesQuestionList,
  );
  yield takeEvery(
    DevOpsAnalyticsActionTypes.GET_CSP_ASSES_QUESTIONS_START,
    getCspAssesQuestionList,
  );
  yield takeEvery(
    DevOpsAnalyticsActionTypes.SUBMIT_SAVE_CSP_ASSES_QUESTIONS_START,
    saveCspAssesQuestionList,
  );
  yield takeEvery(
    DevOpsAnalyticsActionTypes.GET_PLAN_CAPABILITY_LIST_START,
    getPlanCapabilityList,
  );
  yield takeEvery(
    DevOpsAnalyticsActionTypes.SAVE_PLAN_CAPABILITY_LIST_START,
    savePlanCapabilityList,
  );
}
